import { createTheme } from '@mui/material/styles';

import { shadows } from './shadows';
import { typography } from './typography';

import './fonts';
import { palette, fontSizes, fontWeights, fontLineHeights } from './';

export const globalTheme = createTheme({
  palette: {
    primary: palette.brandDarkBlue,
    ...palette,
  },
  fontSizes,
  fontWeights,
  fontLineHeights,
  typography,
  customShadows: shadows,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: '#e8e8e8' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: '18px',
          [theme.breakpoints.down('md')]: {
            fontSize: '16px',
          },
          fontWeight: 500,
          textTransform: 'none',
          variants: [
            {
              props: { variant: 'link' },
              style: {
                background: 'none',
                border: 'none',
                padding: 0,
                textDecoration: 'underline',
                color: 'blue',
                cursor: 'pointer',
                fontSize: 'inherit',
                fontWeight: 'inherit',
                lineHeight: 'inherit',
                '&:hover': {
                  textDecoration: 'none',
                },
              },
            },
          ],
        }),
        contained: ({ theme }) => ({
          width: '100%',
          padding: '6px 16px',
          [theme.breakpoints.down('md')]: {
            padding: '12px 16px',
          },
          textTransform: 'capitalize',
          color: '#FFFFFF',
          backgroundColor: '#578641',
          '&:hover': {
            backgroundColor: '#416331',
          },
          '&:active': {
            backgroundColor: '#89ba73',
          },
          '&:disabled': {
            backgroundColor: '#e8e8e8',
            color: '#5a5a5a',
          },
          [theme.breakpoints.up('md')]: {
            width: 'auto',
          },
        }),
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(3px)',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          marginRight: '10px',
          color: 'transparent',
          '& .MuiSvgIcon-root': {
            outline: `2px solid ${palette.brandGray.main}`,
            borderRadius: '50%',
          },

          '&.Mui-checked': {
            '& .MuiSvgIcon-root': {
              outline: `2px solid ${palette.brandGreen.dark}`,
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: palette.brandGreen.dark,
          },
          '&.Mui-error': {
            color: palette.brandRed.dark,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.brandGreen.dark,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.brandGreen.dark,
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.brandRed.dark,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: palette.brandRed.dark,
          fontWeight: 400,
          marginLeft: 0,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: palette.custom.inputLabel,
          fontSize: '14px',
          fontWeight: 500,
        },
      },
    },
  },
});
